"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DEFAULT_END_TIME: ()=>DEFAULT_END_TIME,
    formatMinutes: ()=>formatMinutes,
    generateTimeOptions: ()=>generateTimeOptions,
    stringToTime: ()=>stringToTime,
    timeIsEqual: ()=>timeIsEqual,
    timeToMinutes: ()=>timeToMinutes,
    timeToString: ()=>timeToString
});
const DEFAULT_END_TIME = {
    hour: 11,
    minute: 59,
    meridiem: 'PM'
};
const timeIsEqual = (time1, time2)=>{
    if (!time1 || !time2) return false;
    return time1.hour === time2.hour && time1.minute === time2.minute && time1.meridiem === time2.meridiem;
};
const timeToString = (time)=>formatMinutes(timeToMinutes(time));
const stringToTime = (time)=>{
    const [hour, minuteMeridiem] = time.trim().split(':');
    const [minute, meridiem] = minuteMeridiem.split(' ');
    return {
        hour: parseInt(hour),
        minute: parseInt(minute),
        meridiem: meridiem
    };
};
const timeToMinutes = (time)=>{
    const meridiemOffset = 'AM' === time.meridiem ? 0 : 720;
    return time.hour % 12 * 60 + time.minute + meridiemOffset;
};
const formatMinutes = (totalMinutes)=>{
    const hour24 = Math.floor(totalMinutes / 60);
    const minute = totalMinutes % 60;
    const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
    const meridiem = hour24 >= 12 ? 'PM' : 'AM';
    const hourStr = hour12.toString();
    const minuteStr = minute.toString().padStart(2, '0');
    return `${hourStr}:${minuteStr} ${meridiem}`;
};
const generateTimeOptions = (interval, startTime, endTime)=>{
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);
    if (endMinutes < startMinutes) throw new Error('endTime must be later than startTime and on the same day');
    const result = [];
    for(let current = startMinutes; current <= endMinutes; current += interval)result.push(formatMinutes(current));
    return result;
};
exports.DEFAULT_END_TIME = __webpack_exports__.DEFAULT_END_TIME;
exports.formatMinutes = __webpack_exports__.formatMinutes;
exports.generateTimeOptions = __webpack_exports__.generateTimeOptions;
exports.stringToTime = __webpack_exports__.stringToTime;
exports.timeIsEqual = __webpack_exports__.timeIsEqual;
exports.timeToMinutes = __webpack_exports__.timeToMinutes;
exports.timeToString = __webpack_exports__.timeToString;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DEFAULT_END_TIME",
    "formatMinutes",
    "generateTimeOptions",
    "stringToTime",
    "timeIsEqual",
    "timeToMinutes",
    "timeToString"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
